import React from 'react';
import { motion } from 'framer-motion'; 
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './easy-hub.css';
import toDoListImage from '../../../assets/images/spotifyuiclone.png';

const ToDoListApp = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Spotify UI <span>Clone</span>
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Last Updated On: 11th July 2026
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={toDoListImage} alt="To-Do List App" className="project-image" />
          <h2 className="project-subtitle">Spotify UI Clone</h2>
          <span className="project-category">Website</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="spotifyClone" trackView={true} />

          {/* Buttons */}
          <div className="project-buttons">
            <a href="https://project-tap-assignment-9.netlify.app/" className="visit-project-button">
              → Visit the Project
            </a>
            <a href="https://github.com/Praveenkumar-king/Spotify-UI-Clone" className="visit-project-button">
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "spotifyClone",
                title: "Spotify UI Clone",
                path: "/projects/projectdetail/spotify-clone"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Project Details</h3>
          <p className="overview-text">
           Welcome to <strong>Spotify UI Clone</strong>! Here's a detailed overview of the Spotify UI Clone Website.
          </p>

          <h3 className="section-title">Overview 🌟</h3>
          <p className="overview-description">
            The <strong>Spotify UI Clone</strong> is a modern music streaming interface inspired by Spotify. It recreates the overall user experience with a sleek dark theme, responsive layouts, playlist browsing, and an interactive music player using modern front-end technologies.
          </p>

          <h3 className="section-title">Key Features of the App 🛠️</h3>
          <ul className="feature-list">
            <li><strong>Music Player</strong> 🎵 - Interactive player with play, pause, next, previous, and volume controls.</li>
            <li><strong>Playlist & Albums</strong> 📀 - Browse featured playlists, albums, and artist collections.</li>
            <li><strong>Responsive Design</strong> 📱 - Optimized for mobile, tablet, and desktop devices.</li>
             <li><strong>Modern UI</strong> 🎨 - Clean dark theme with smooth hover effects and animations.</li>
          </ul>


          <h3 className="section-title">Technical Details ⚙️</h3>
          <ul className="technical-details-list">
              <li><strong>Frontend</strong> 🖥️ - HTML5, CSS3, and JavaScript (ES6).</li>
            <li><strong>Animations</strong> ✨ - Framer Motion for smooth page transitions.</li>
            <li><strong>Responsive Layout</strong> 📱 - Built with CSS Flexbox, Grid, and Media Queries.</li>
            <li><strong>Deployment</strong> ☁️ - Hosted on Netlify with GitHub for version control.</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>The <strong>Spotify UI Clone</strong> demonstrates a modern music streaming interface with responsive layouts, playlist browsing, an interactive player, and a premium dark-themed design. It showcases strong front-end development skills and modern UI implementation.</p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ToDoListApp;
